function initialState() {
    return {

        dummyConfig: {}
    }
}

export default {
    state: initialState(),
    getters: {
        DUMMY_UI_CONFIG: state => state.dummyConfig_ui,
        DUMMY_CONFIG: state => state.dummyConfig
    },
    mutations: {
        SET_DUMMY_UI_CONFIG(state, payload) {
            state.dummyConfig_ui = payload;
        },
        SET_DUMMY_CONFIG(state, payload) {
            state.dummyConfig = payload;
        },
    },
    actions: {

    }
}
